<template>
  <div class="all-users-page">
    <h1 class="page-header color-1-100">Industries</h1>
    <div class="content-section">
      <div class="data-list-heading">
        <router-link :to="{name: 'add-industry'}" class="data-list-add" tabindex="-1">Add new industry</router-link>
      </div>
      <div class="data-list-selected-filters" v-if="getDeviceType('desktop') && selectedFilters.length">
        <div class="data-list-selected-filters-applied">
          <span>Filters applied:<br/>{{ this.filteredIndustryList.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button v-for="filter in selectedFilters"
                  type="button"
                  @click="removeSelectedFilters(filter)"
                  @mouseover="addHoverElement([filter])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(filter)}">
            <span>{{ filter.label }}</span>
          </button>
          <span class="data-list-selected-filters-remove-all"
                @click="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
        </div>
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead v-bind:filters="getTabletFiltersAppliedText()">
          <tr>
            <th class="data-list-search-col text-left column-search-head table-head-ceil" colspan="2"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 1,
                'hover-head-ceil': isExistSearchInOptions('name')}"
                @mouseover="addSearchHoverElement('name')"
                @mouseleave="removeSearchHoverElements">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                    title="ID and industry name"
                    aria-label="ID and industry name"
                    v-model="searchByName"
                    type="search"
                    class="table-search"
                    placeholder="ID and industry name" />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="data-list-search-col text-left column-search-head table-head-ceil"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 2,
                'hover-head-ceil': isExistSearchInOptions('parent')}"
                @mouseover="addSearchHoverElement('parent')"
                @mouseleave="removeSearchHoverElements">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                    title="Parent industry"
                    aria-label="Parent industry"
                    v-model="searchByParent"
                    type="search"
                    class="table-search"
                    placeholder="Parent industry" />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="column-created-head table-head-ceil"
                @click.stop="changeOrderBy('companies', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">No. of companies</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.industryOrderBy !== null && this.industryOrderBy.type === 'companies' && this.industryOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.industryOrderBy !== null && this.industryOrderBy.type === 'companies' && !this.industryOrderBy.order}"></div>
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(industry, i) in filteredIndustryList" @click="goToIndustryEdit(industry.id)" v-if="i < offset">
            <td class="id-cell text-center cellpadding" style="width: 40px;" data-title="ID" v-if="industry.type === 'show'">{{ industry.id }}</td>
            <td class="name-cell cellpadding" data-title="ID and full name:" v-if="industry.type === 'show'"><span v-if="getDeviceType('tablet') || getDeviceType('mobile')">{{ industry.id }} </span>{{ industry.name }}</td>
            <td class="industry-cell cellpadding" data-title="Parent industry:" v-if="industry.type === 'show'">{{ industry.parent ? industry.parent.name : 'n/a' }}</td>
            <td class="last-login-cell cellpadding text-center" data-title="No. of companies" v-if="industry.type === 'show'">{{ industry.companies }}</td>
          </tr>
          </tbody>
        </table>
        <div class="load-more-container" v-if="this.offset <= this.filteredIndustryList.length">
          <div class="load-more-btn" @click="loadMore()">
            <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
          </div>
        </div>
      </div>
    </div>
    <app-spiner v-if="false" />
  </div>
</template>

<script>
import api from '@/api'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/ban'
import { mapGetters, mapActions } from 'vuex'
import AppSelect from '@/components/admin/common/Select'

export default {
  name: 'industry-list',
  data () {
    return {
      ppt: 15,
      offset: 15,
      industries: [],
      filteredIndustryList: [],
      selectedAction: null,
      search: '',
      table: '',
      head: '',
      searchByName: '',
      searchByParent: '',
      hoverSearchElements: [],
      industry: null,
      parentIndustryList: [],
      industryOrderBy: {
        type: '',
        order: false
      },
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      statusbar: {
        data: [],
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      windowWidth: window.innerWidth
    }
  },
  methods: {
    ...mapActions([
      'getCompanies',
      'getRoles',
      'setInformationMsg'
    ]),
    fetchAllContentByScroll (page, limit) {
      this.$http.get(api.URLS.industryList + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          let industries = res.body.items
          let parents = []
          industries.sort((a, b) => a.name > b.name).forEach(function (company) {
            if (company.parent === null) {
              let children = industries.filter(item => item.parent !== null && item.parent.id === company.id)
              parents.push(company)
              children.forEach(function (child) {
                parents.push(child)
              })
            }
          })
          this.industries = parents
          this.statusbar.data = res.body.count ? res.body.count : []
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    addSearchHoverElement (type) {
      this.hoverSearchElements = type
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    removeSearchHoverElements () {
      this.hoverSearchElements = ''
    },
    isExist (element) {
      if (element.type !== undefined && this.hoverSearchElements === element.type) {
        return true
      }
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistSearchInOptions (type) {
      let hoverElement = this.hoverSearchElements ? this.hoverSearchElements : ''
      if (hoverElement === type) {
        return true
      }
    },
    removeSelectedFilters (filter) {
      if (this.searchByName) {
        this.searchByName = ''
      }
      if (this.searchByParent) {
        this.searchByParent = ''
      }
      if (this.industryStatus && this.industryStatus.label === filter.label && this.industryStatus.value === filter.value) {
        this.industryStatus = null
      }
    },
    removeAllFilters () {
      this.searchByName = ''
      this.searchByParent = ''
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    changeOrderBy (type, order) {
      this.industryOrderBy = {
        type: type,
        order: this.industryOrderBy !== null ? !this.industryOrderBy.order : order
      }
    },
    goToIndustryEdit (id) {
      let props = this.$router.resolve({
        name: 'edit-industry',
        params: {id: id}
      })
      location.href = props.href
    },
    loadMore () {
      this.offset = this.offset + this.ppt
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width >= 940) {
        deviceName = 'desktop'
      } else if (width >= 480) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    getTabletFiltersAppliedText () {
      let filterAppliedText = 'Apply Filters'
      if (this.selectedFilters.length) {
        filterAppliedText = 'Filters applied: ' + this.industries.length + ' results'
      }
      return filterAppliedText
    },
    randomNumber: function () {
      return Math.floor(Math.random() * (10 - 1 + 1)) + 1
    }
  },
  computed: {
    ...mapGetters([]),
    getCompaniesForSelect () {
      return this.parentIndustryList
    },
    filteredCompanies () {
      let result = this.industries
      result = this.industries.filter((industry) => (industry.id + ' ' + industry.name).toLowerCase().indexOf(this.searchByName.toLowerCase()) > -1)
      if (this.industryOrderBy !== null && this.industryOrderBy.type !== '') {
        let ascDesc = this.industryOrderBy.order ? 1 : -1
        if (this.industryOrderBy.type === 'companies') {
          result = result.sort((a, b) => ascDesc * (a.companies.length - b.companies.length))
        }
      }
      if (this.searchByParent) {
        result = result.filter((industry) => industry.parent !== null && (industry.parent.name).toLowerCase().indexOf(this.searchByParent.toLowerCase()) > -1)
      }
      return result
    },
    selectedFilters () {
      let filters = []
      if (this.searchByName) {
        filters.push({
          id: null,
          type: 'name',
          label: this.searchByName
        })
      }
      if (this.searchByParent) {
        filters.push({
          id: null,
          type: 'parent',
          label: this.searchByParent
        })
      }
      return filters
    }
  },
  watch: {
    filteredCompanies () {
      let filteredIndustryList = []
      this.offset = this.ppt
      this.parentIndustryList = []
      this.filteredCompanies.forEach((industry) => {
        industry.type = 'show'
        filteredIndustryList.push(industry)
      })
      this.filteredIndustryList = filteredIndustryList
    }
  },
  components: {
    AppSelect
  },
  mounted () {
    this.fetchAllContentByScroll(1, 500)
    // this.getCompanies()
    // this.getRoles()
    document.addEventListener('click', this.hideSubMenuTableHead)
    window.addEventListener('resize', this.handleWindowResize)
  },
  created () {
    document.title = 'All industries | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' ></style>




// WEBPACK FOOTER //
// IndustryList.vue?194120fc